<div class="p-5" *ngIf="derivativeEntries?.length">
  <h3 class="ds-heading--xs">{{'checkout.additionalSolutions' | cxTranslate}}</h3>
  <div class="mt-4" *ngFor="let entry of derivativeEntries">
    <div class="d-flex flex-nowrap justify-content-between">
      <div
        class="ds-body">{{entry.product.name}} {{'common.braces' | cxTranslate: {parameter: entry?.product?.supplierAlternativeAID} }}</div>
      <div class="ds-heading--xs ds-font--regular text-nowrap">{{dcpOrderEntryService.getSubtotal(entry)}}</div>
    </div>
  </div>
</div>
